import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

export function CostConfigurationsInfoContent() {
  return (
    <div>
      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="profitability.cost-configurations.info.how-costs-calculated.title" />
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, fontWeight: 300 }}>
        <FormattedMessage id="profitability.cost-configurations.info.how-costs-calculated.description" />
      </Typography>

      <hr className="my-4 border-snow-200" />

      <InfoContentItem
        titleId="profitability.cost-configurations.info.cogs.title"
        descriptionId="profitability.cost-configurations.info.cogs.description"
      />
      <InfoContentItem
        titleId="profitability.cost-configurations.info.marketplace-fees.title"
        descriptionId="profitability.cost-configurations.info.marketplace-fees.description"
      />
      <InfoContentItem
        titleId="profitability.cost-configurations.info.payment-fees.title"
        descriptionId="profitability.cost-configurations.info.payment-fees.description"
      />
      <InfoContentItem
        titleId="profitability.cost-configurations.info.logistics-costs.title"
        descriptionId="profitability.cost-configurations.info.logistics-costs.description"
      />

      <hr className="my-4 border-snow-200" />

      <InfoContentItem
        titleId="profitability.cost-configurations.info.defaults-overrides.title"
        descriptionId="profitability.cost-configurations.info.defaults-overrides.description"
      />
    </div>
  );
}
